export const GET_DATA_LOADING_HOME = "GET_DATA_LOADING_HOME";
export const GET_DATA_SUCCESS_CLOTH = "GET_DATA_SUCCESS_CLOTH";
export const GET_DATA_SUCCESS_SHOE = "GET_DATA_SUCCESS_SHOE";
export const GET_DATA_ERROR_HOME = "GET_DATA_ERROR_HOME";